import { ActionMenuItem } from '@shared/components/action-menu/action-menu-item.model';
import { CHECK_PERMISSIONS } from '@shared/modules/permissions.module';
import { CompanyDetailsActions } from './company-details-actions-enum';
import { useActionMenuComposable } from '@shared/components/action-menu/action-menu-composable';

export const useCompanyDetailsActionMenu = () => {
  // Composable logic for navigation menu can be added here
  const validatePermission = CHECK_PERMISSIONS();
  const actionMenuHelper = useActionMenuComposable();
  const companyDetailsActionMenuItems: ActionMenuItem[] = [
    {
        title:'Edit',
        icon:'edit',
        route:'/companies',
        validPermission: validatePermission.canReadCompanies(),
        action: CompanyDetailsActions.Edit,
    },
    {
        title:'Deactivate',
        statefulTitle: actionMenuHelper.getTruthyStatefulTitle,
        icon:'block',
        route:'/companies',
        validPermission: validatePermission.canReadCompanies(),
        action: CompanyDetailsActions.Toggled,
    },
  ];
  return{
    companyDetailsActionMenuItems
  }
};